export interface IOnboardingStep {
  title: string;
  message: string;
  resource: string;
  completedMessage: string;
  route: string;
  nextRoute: string;
}

export interface IOnboardingDataType {
  home: IOnboardingStep;
  company: IOnboardingStep;
  farm: IOnboardingStep;
  machines: IOnboardingStep;
  chemicals: IOnboardingStep;
  crops: IOnboardingStep;
  varieties: IOnboardingStep;
  blocks: IOnboardingStep;
  employees: IOnboardingStep;
  sprayRecord: IOnboardingStep;
  report: IOnboardingStep;
}

export const OnboardingData: IOnboardingDataType = {
  home: {
    title: 'GrowData FMP',
    message:
      'Welcome to GrowData FMP. We will guide you step by step to set up all the necessary resources to access everything we offer. Start with the initial setup by clicking the Next Step button',
    resource: '',
    completedMessage: 'Thank you for following the onboarding process. You can go through it again whenever you need.',
    route: '/',
    nextRoute: '/company/create',
  },
  company: {
    title: 'Business Detail',
    message:
      "In this section, you can enter your company's details. This is an essential step to continue with the application setup",
    resource: 'Tenants',
    completedMessage:
      'You have already registered a company. When you signed up, one was assigned to you by default. In this form, you can update the necessary details of your company. If you wish, you can update the information or proceed to the next step of the process',
    route: '/company/create',
    nextRoute: '/farm/create',
  },
  farm: {
    title: 'Farm Detail',
    message:
      'In this section, you can register a Farm. This is an essential step to continue with the application setup',
    resource: 'Farms',
    completedMessage: 'You have already registered a farm.',
    route: '/farm/create',
    nextRoute: '/machine/create',
  },
  machines: {
    title: 'Machine',
    message:
      'Here you can register the machines you will use in your business. This step is important to properly manage your resources',
    resource: 'Machines',
    completedMessage: 'You have machines registered. You can add more if you wish or proceed to the Next Step',
    route: '/machine/create',
    nextRoute: '/chemical/create',
  },
  chemicals: {
    title: 'Chemical',
    resource: 'ChemicalDetails',
    message:
      'Register the chemicals you will use. This will help maintain precise control over the supplies used in your business',
    completedMessage: 'You have chemicals registered. You can add more products or proceed to the Next Step',
    route: '/chemical/create',
    nextRoute: '/crop/create',
  },
  crops: {
    title: 'Crops',
    message:
      'In this section, you can add the crops you will manage. This is crucial for planning and tracking your agricultural activities.',
    resource: 'Crops',
    completedMessage: 'You have crops registered. You can add more crops or proceed to the Next Step',
    route: '/crop/create',
    nextRoute: '/variety/create',
  },
  varieties: {
    title: 'Variety',
    message:
      'Here you can register the crop varieties you manage. This will allow you to keep more detailed control of your products. Remember, to add a variety, you need a crop',
    resource: 'Varieties',
    completedMessage: 'You have varieties registered. You can add more varieties or proceed to the Next Step.',
    route: '/variety/create',
    nextRoute: '/block/create',
  },
  blocks: {
    title: 'Block',
    message:
      'Define the blocks or plots where your products will be grown. This will help you better organize your products and activity records.',
    resource: 'Blocks',
    completedMessage: 'You have blocks registered. You can add more blocks or proceed to the Next Step.',
    route: '/block/create',
    nextRoute: '/employee/create',
  },
  employees: {
    title: 'Employee',
    message:
      'Here you can add the employees who will work in your business. You will manage your team effectively from this section',
    resource: 'Employees',
    completedMessage:
      'You have employees registered. You can add more employees if needed or continue with the process',
    route: '/employee/create',
    nextRoute: '/spray-record',
  },
  sprayRecord: {
    title: 'Spray Record',
    message: "Here you view and create a Spray Record. Helping you to effectively manage your team's assignments.",
    resource: 'SprayRecords',
    completedMessage:
      'You have Spray Records registered. You can create more Spray Records if needed or continue with the process',
    route: '/spray-record',
    nextRoute: '/reports/spray-records',
  },
  report: {
    title: 'Report',
    message: 'Here you can create a report. You need to create a Spray Record first in order to generate reports.',
    resource: 'SprayRecords',
    completedMessage: 'Here you can see the consolidated information of the spray diary.',
    route: '/reports/spray-records',
    nextRoute: '/',
  },
};
